import { render, staticRenderFns } from "./Finished_Returnlabel.vue?vue&type=template&id=48c30617&scoped=true&"
import script from "./Finished_Returnlabel.vue?vue&type=script&lang=js&"
export * from "./Finished_Returnlabel.vue?vue&type=script&lang=js&"
import style0 from "./Finished_Returnlabel.vue?vue&type=style&index=0&id=48c30617&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c30617",
  null
  
)

export default component.exports